// libraries
import React, { useEffect, useState } from 'react'
import WithHeader from '../components/WithHeader'
import { View } from 'react-native'
import EntityField from '../components/EntityField'
import MSFESButton from '../components/MSFESButton'
import spacing from '../styles/spacing'

import { PermissionsEditor } from '../components/Permissions/PermissionsEditor'
import { useTenantOrGlobalAdmin } from '../hooks/useTenantOrGlobalAdmin'
export default function SettingsManagePermissionsScreen({ navigation, route }) {
  const [state, setState] = useState({
    tenant: route?.params?.tenant ?? null,
    role: route?.params?.role ?? null,
    personnelId: route?.params?.personnelId ?? null,
    personnelName: route?.params?.personnelName ?? null
  })

  const [page, setPage] = useState(
    route?.params?.tenant ?? route.params?.role ?? route?.params?.personnelId
      ? 2
      : 1
  )

  const { tenant } = useTenantOrGlobalAdmin()

  useEffect(() => {
    if (tenant) {
      setState((state) => ({ ...state, tenant: tenant.id }))
    }
  }, [tenant])

  return (
    <WithHeader
      title={'Manage Permissions'}
      navigation={navigation}
      leftButtonType={'back'}
    >
      {/* {loading && <GlobalLoading />} */}
      {page === 1 && (
        <View style={{ flex: 1, margin: spacing.m2 }}>
          <EntityField
            horizontal
            mode={'edit'}
            entity={state}
            name={'tenant'}
            errorMessage={null}
            defaultValue={state.tenant}
            field={{
              title: 'Tenant',
              field_data: {
                params: {
                  readonly: !!tenant
                },
                property: 'tenant',
                type: 'select-tenant'
              }
            }}
            fieldChanged={(propertyContainer, tenantId) => {
              setState((state) => ({ ...state, tenant: tenantId }))
            }}
          />
          <EntityField
            horizontal
            mode={'edit'}
            entity={state}
            name={'role'}
            errorMessage={null}
            defaultValue={state.role}
            field={{
              title: 'Role',
              field_data: {
                property: 'role',
                type: 'select-role',
                params: {
                  readonly: !!state.personnelId
                }
              }
            }}
            fieldChanged={(propertyContainer, roleId) => {
              setState({ ...state, role: roleId })
            }}
          />
          <EntityField
            horizontal
            mode={'edit'}
            entity={state}
            name={'personnel'}
            errorMessage={null}
            defaultValue={state.personnelId}
            field={{
              title: 'Personnel',
              field_data: {
                property: 'personnel',
                params: {
                  readonly: !!state.role,
                  tenantFilter: state.tenant ?? undefined
                },
                type: 'select-personnel'
              }
            }}
            fieldChanged={(propertyContainer, personnel) => {
              setState({
                ...state,
                personnelId: personnel.id,
                personnelName: personnel.display_name
              })
            }}
          />
          <MSFESButton
            containerStyle={[spacing.mr1]}
            title={`Edit Permissions`}
            onPress={() => {
              navigation.setParams({
                tenant: state.tenant ?? 'global',
                role: state.role ?? undefined,
                personnelId: state.personnelId ?? undefined,
                personnelName: state.personnelName ?? undefined
              })
              setPage(2)
            }}
          />
        </View>
      )}
      {page === 2 && (
        <View style={{ flex: 1 }}>
          <PermissionsEditor
            {...state}
            navigation={navigation}
            setPage={setPage}
          />
        </View>
      )}
    </WithHeader>
  )
}
